var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import { Box, breakpoint, Modal, Text } from '@bfa/common-ui';
import React from 'react';
import styled from 'styled-components';
var StyledBox = styled(Box)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  @media only screen and (min-width: ", ") {\n    width: 55.4rem;\n  }\n"], ["\n  @media only screen and (min-width: ", ") {\n    width: 55.4rem;\n  }\n"])), breakpoint('sm'));
var TermsOfServiceModal = function (_a) {
    var showModal = _a.showModal, onClick = _a.onClick, text = _a.text;
    return (React.createElement(Modal, { isOpen: showModal, showDismiss: true, onDismiss: onClick, showOnTop: true, margin: "7.5rem 1.5rem 0" },
        React.createElement(StyledBox, { textAlign: "center", padding: ['3.2rem 0 1.5rem', '3.2rem 9.6rem 3rem'] },
            React.createElement(Text, { fontSize: "2.2rem", lineHeight: "3.3rem", bold: true, letterSpacing: "0.02rem" }, "Refreshments Service"),
            React.createElement(Text, { fontSize: "1.4rem", lineHeight: "1.7rem", color: "#767676" }, text))));
};
export default TermsOfServiceModal;
var templateObject_1;
